import { useI18n } from 'next-localization';

import { GenericModal } from '@/components/modals';

import { TIME_UNAVAILABLE_MODAL } from '../constants';

interface Props {
  onModalAccept: () => void;
  onModalDecline: () => void;
  skipDeclineHandlerOnDismiss?: boolean;
}

// Todo: combine this and time released modal in one component, they are the same
export const TimeUnavailableModal = ({
  onModalAccept,
  onModalDecline,
  skipDeclineHandlerOnDismiss,
}: Props): JSX.Element => {
  const { t } = useI18n();
  return (
    <GenericModal
      name={TIME_UNAVAILABLE_MODAL}
      label=""
      acceptButtonText={t('OAS.Common.Refresh')}
      declineButtonText={t('OAS.Booking.Appointment.TimeUnavailableModal.Profile')}
      handleModalAccept={onModalAccept}
      handleModalDecline={onModalDecline}
      skipDeclineHandlerOnDismiss={skipDeclineHandlerOnDismiss}
    >
      <h3 className="mb-4">{t('OAS.Booking.Appointment.TimeUnavailableModal.Title')}</h3>
      <p>{t('OAS.Booking.Appointment.TimeUnavailableModal.Text')}</p>
    </GenericModal>
  );
};
